import { useEffect } from "react";
import ClassName from "./ClassName";
import StudentTable from "./StudentTable/StudentTable";
import useAppDispatch from "hooks/useAppDispatch";
import {
  resetSelectedStudents,
  resetSortBy,
  resetStudent,
} from "features/student/studentSlice";

const StudentPage = () => {
  const dispatch = useAppDispatch();
  const reset = () => {
    dispatch(resetSelectedStudents());
    dispatch(resetSortBy());
    dispatch(resetStudent());
  };

  useEffect(() => {
    document.addEventListener("back", reset);

    return () => {
      document.removeEventListener("back", reset);
    };
  }, []);

  return (
    <section className="h-full min-h-0 space-y-3 lg:space-y-5 flex flex-col">
      <ClassName />
      <StudentTable />
    </section>
  );
};

export default StudentPage;
